import * as R from 'ramda'
import { isActionOneOfTypes } from 'helpers/ramda-ext/actions'
import * as Actions from 'store/actions'
import { RegisteredAction } from 'store/actions/index.types'
import { InitialState, State } from './errors.types'

export const initialState: InitialState = []

// eslint-disable-next-line @typescript-eslint/default-param-last
export default (state: State = initialState, action: RegisteredAction): State => R.cond([
  [
    isActionOneOfTypes([
      Actions.resources.EMPTY_SALE_RESOURCES_ERROR,
      Actions.resources.FETCH_RESOURCE_ERROR,
      Actions.version.FETCH_VERSION_ERROR,
      Actions.errors.NETWORK_ERROR
    ]),
    R.append(R.__, state)
  ], [
    R.T,
    R.always(state)
  ]
])(action)
